import { FC } from 'react';
import { ServiceOption } from '../serviceOption.types';
import { FormattedMessage } from 'react-intl';
import { Table } from '../../../sharedComponents/table/Table';
import { ServiceOptionsTableColumns } from './ServiceOptionsTableColumns';
import { ServiceOptionRow } from './ServiceOptionTableRow';
import { TableSort } from '../../../sharedComponents/table/SortedTableHeader';
import { getServiceOptionSort, serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { useSelectedTableColumns } from '../../../sharedComponents/table/useSelectedTableColumns';

type ServiceOptionsTableProps = {
    serviceOptions: ServiceOption[];
};

export const ServiceOptionsTable: FC<ServiceOptionsTableProps> = ({ serviceOptions }) => {
    const dispatch = useAppDispatch();
    const sorting = useAppSelector(getServiceOptionSort);
    const setSorting = (newSorting: TableSort<ServiceOptionsTableColumns>) =>
        dispatch(serviceOrdersSlice.actions.setSortingForServiceOptions({ sort: newSorting }));

    const columnDefinition = useSelectedTableColumns<ServiceOptionsTableColumns>();

    return (
        <Table
            columnDefinition={columnDefinition}
            notFoundMessage={<FormattedMessage id="outboundOrderBook.serviceOptions.notFound" />}
            sorting={sorting}
            setSorting={setSorting}
            items={serviceOptions}
        >
            {serviceOptions.map((serviceOption: ServiceOption) => (
                <ServiceOptionRow key={serviceOption.id} serviceOption={serviceOption} columns={columnDefinition} />
            ))}
        </Table>
    );
};
